export const subtitles = {
    "1": {
        "startTime": 8.46,
        "endTime": 10.23,
        "transcript": "Alrighty.",
        "translation": "Alrighty."
    },
    "2": {
        "startTime": 10.58,
        "endTime": 12.29,
        "transcript": "We're rolling.",
        "translation": "We're rolling."
    },
    "3": {
        "startTime": 19.03,
        "endTime": 19.87,
        "transcript": "Ready?",
        "translation": "Ready?"
    },
    "4": {
        "startTime": 19.875,
        "endTime": 20.885,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "5": {
        "startTime": 20.885,
        "endTime": 28.115,
        "transcript": "For the record, Nicholai and Olenka K. Nicholai of Kuiggluk.",
        "translation": "For the record, Nicholai and Olenka K. Nicholai of Kwethluk."
    },
    "6": {
        "startTime": 28.115,
        "endTime": 32.71,
        "transcript": "Qugiciq and Angut'aq.",
        "translation": "Qugiciq and Angut'aq."
    },
    "7": {
        "startTime": 32.71,
        "endTime": 33.95,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "8": {
        "startTime": 33.955,
        "endTime": 43.245,
        "transcript": "Makunek tua-ll' ak'alla'arnek apqauriukut maavet Kuigglugmun tailuta.",
        "translation": "So, we came here to Kwethluk to ask about things of old."
    },
    "9": {
        "startTime": 46.215,
        "endTime": 50.515,
        "transcript": "Aipan, aipan apteqerru waten:",
        "translation": "Please ask your spouse this:"
    },
    "10": {
        "startTime": 50.82,
        "endTime": 58.32,
        "transcript": "Ak'a-gguq-qaa tamaani yuut... nuu.",
        "translation": "Did people long ago... no."
    },
    "11": {
        "startTime": 58.745,
        "endTime": 64.815,
        "transcript": "Man'a-qaa Kusquqvak nunalillruuq yugnek quyungqalrianek?",
        "translation": "Were there a lot of settlements where people gathered her in the Kuskokwim?"
    },
    "12": {
        "startTime": 64.815,
        "endTime": 68.875,
        "transcript": "Iciw' maa-i caugat?",
        "translation": "You know, what are they now?"
    },
    "13": {
        "startTime": 69.02,
        "endTime": 77.42,
        "transcript": "Urucararmiut, Mamterillermiut, Napaskiaq, Kuiggayagaq, Tuntutuliaq, Naparyarraq.",
        "translation": "Urucararmiut, Bethel, Napaskiak, Oscarville, Tuntutuliak, Napakiak."
    },
    "14": {
        "startTime": 77.425,
        "endTime": 78.7,
        "transcript": "Qavcirrauluteng.",
        "translation": "There are only several."
    },
    "15": {
        "startTime": 78.7,
        "endTime": 81.61,
        "transcript": "Ak'a tamaani-qaa amllelallruut?",
        "translation": "Were there a lot a long time ago?"
    },
    "16": {
        "startTime": 83.64,
        "endTime": 88.6,
        "transcript": "Nunat-gguq-qaa murilkengqerraallerpeni amllellruut?",
        "translation": "He said, were there a lot of villages when you first became observant?"
    },
    "17": {
        "startTime": 88.605,
        "endTime": 92.425,
        "transcript": "Nuu, yugyallrunrituq.",
        "translation": "No, there weren't a lot of people."
    },
    "18": {
        "startTime": 92.441,
        "endTime": 104.998,
        "transcript": "Atam tan'gurra'urluulua qaillun tayima, waten aipaagni angtaunga, tau͡gaam tua-i murilkellua, ellanglua-w' tua-i ellakemnek.",
        "translation": "You see, when I was a boy at some height, I was probably this big, but I was observant, well, I had became aware."
    },
    "19": {
        "startTime": 105.842,
        "endTime": 121.597,
        "transcript": "Kanani tua-i Wass-am eniini avatiini tamaani kiaqlikacaar.",
        "translation": "Down around Wass' house, the furthest upriver."
    },
    "20": {
        "startTime": 122.562,
        "endTime": 133.276,
        "transcript": "Man'a-ll' kiatii cataunani, imkunek tau͡gaam yuguanek muragnek.",
        "translation": "And there was nothing here upriver from there, except for those wooden human figures."
    },
    "21": {
        "startTime": 134.436,
        "endTime": 138.478,
        "transcript": "Tua-i tamakunek tau͡gaam.",
        "translation": "That was all there was."
    },
    "22": {
        "startTime": 138.907,
        "endTime": 139.95,
        "transcript": "Qungunek.",
        "translation": "Graves."
    },
    "23": {
        "startTime": 139.961,
        "endTime": 146.632,
        "transcript": "Tua-i-llu (Qungut.) Dutch-am enii kiaqlikacagaungan",
        "translation": "Then (Graves.) since Dutch's house was the furthest upriver"
    },
    "24": {
        "startTime": 147.827,
        "endTime": 156.37,
        "transcript": "Wangkuta ketiini kanani eneluta.",
        "translation": "We had a house down there toward the water from there."
    },
    "25": {
        "startTime": 157.581,
        "endTime": 166.61,
        "transcript": "Una-w' apa'urluirutka Kukikcaq kiaqlikacagaullrulria. Tua-i murilkellua.",
        "translation": "And my late grandfather, Kukikcaq, was the furthest upriver. That's what I observed."
    },
    "26": {
        "startTime": 168.627,
        "endTime": 176.498,
        "transcript": "Taukut tuani wangkuta akultuvkenata.",
        "translation": "Those there, and we were not spread far apart."
    },
    "27": {
        "startTime": 176.977,
        "endTime": 184.448,
        "transcript": "Tua-i-llu wani keluaraani, enemta waten keluaraani",
        "translation": "Then here right behind it, right behind our house like this"
    },
    "28": {
        "startTime": 184.605,
        "endTime": 198.462,
        "transcript": "Kat'um Vera-m unstii angun tuani enengqellruuq wii nakmiin ilamnek arnamek aiparluni.",
        "translation": "The late father of Vera down there had a house, with my female blood relative as his spouse."
    },
    "29": {
        "startTime": 199.754,
        "endTime": 203.097,
        "transcript": "Yuglutek.",
        "translation": "They had children."
    },
    "30": {
        "startTime": 207.893,
        "endTime": 217.265,
        "transcript": "Tua-i tamaani tamatum nuniini",
        "translation": "Around that time"
    },
    "31": {
        "startTime": 218.506,
        "endTime": 224.077,
        "transcript": "Takumni Slaavillruut.",
        "translation": "They celebrated Russian Christmas in my presence."
    },
    "32": {
        "startTime": 225.68,
        "endTime": 235.451,
        "transcript": "Tua-i-llu erpailgan cayugnaunaku caarkairulluteng.",
        "translation": "Then before anything happened before dawn, they had nothing left to do."
    },
    "33": {
        "startTime": 237.937,
        "endTime": 244.778,
        "transcript": "Tuani tua-i Slaavilrianun, ilakluta-w' tua-i.",
        "translation": "We celebrated Russian Christmas together then."
    },
    "34": {
        "startTime": 245.667,
        "endTime": 255.61,
        "transcript": "Qakemna-llu itraqata taum itlemta elatii yugtailngat'lallruuq.",
        "translation": "And out there when they came in, there didn't seem to be anyone outside the house we went into."
    },
    "35": {
        "startTime": 260.655,
        "endTime": 274.598,
        "transcript": "Ukut tau͡gaam atutulit tua-i ciuqlirraqluki, ayagluta-w' tua-i.",
        "translation": "We would go with the singers going first."
    },
    "36": {
        "startTime": 275.654,
        "endTime": 283.897,
        "transcript": "Erpailgan-llu qaqiulluteng (Ii-i) cayugnaunaku.",
        "translation": "And they finished before dawn (I see.) without any mishaps."
    },
    "37": {
        "startTime": 284.803,
        "endTime": 287.317,
        "transcript": "Imkut-gguq-qaa...",
        "translation": "Ask if those..."
    },
    "38": {
        "startTime": 287.342,
        "endTime": 288.956,
        "transcript": "Yaani-w'...",
        "translation": "Over there..."
    },
    "39": {
        "startTime": 288.964,
        "endTime": 291.335,
        "transcript": "Oh nuu, yaa, ca?",
        "translation": "Oh no, yes, what?"
    },
    "40": {
        "startTime": 293.393,
        "endTime": 304.15,
        "transcript": "Yaani ingkut qungut kelistat, tamana cataunaku",
        "translation": "When those crosses on the graves over there were not present"
    },
    "41": {
        "startTime": 304.168,
        "endTime": 314.725,
        "transcript": "Kanani ketiini napat iluatni uaqlikacaar ena.",
        "translation": "Down toward the water in the trees was the house furthest downriver."
    },
    "42": {
        "startTime": 318.009,
        "endTime": 323.723,
        "transcript": "Ing'um, Paniluk-qaa nallunritan?",
        "translation": "Over there, do you know Paniluk?"
    },
    "43": {
        "startTime": 326.114,
        "endTime": 334.142,
        "transcript": "Taum, taum atii enengqellruuq tuaten napat, napat akuliitni.",
        "translation": "Her father had a house like that among the trees."
    },
    "44": {
        "startTime": 335.529,
        "endTime": 338.986,
        "transcript": "Wiinga apa'urluqliniluku.",
        "translation": "He was apparently my great-uncle."
    },
    "45": {
        "startTime": 339.003,
        "endTime": 353.246,
        "transcript": "Itraqama tua-i ilangciarangraanga wii tamaani caciq nalluamku qaill' piyuksaunii.",
        "translation": "When I went in, though he teased me, I didn't react because I didn't know the custom."
    },
    "46": {
        "startTime": 353.263,
        "endTime": 356.334,
        "transcript": "Cunaw' ilangciaralallinikiinga.",
        "translation": "It turned out that he would tease me."
    },
    "47": {
        "startTime": 363.892,
        "endTime": 370.163,
        "transcript": "Pulayarartarluni-ll' ketiini ikamraryaranek.",
        "translation": "There was also a path through the thickets for sleds."
    },
    "48": {
        "startTime": 370.177,
        "endTime": 379.22,
        "transcript": "Uaggun un'um kuigem paingani ukakaraakun atraumaluteng.",
        "translation": "It went down downriver on this side of the mouth of the river."
    },
    "49": {
        "startTime": 379.239,
        "endTime": 382.882,
        "transcript": "Unaggun ikamrayuunateng.",
        "translation": "They wouldn't use sleds down [toward the river]."
    },
    "50": {
        "startTime": 383.572,
        "endTime": 386.544,
        "transcript": "Tuaten nallunritaqa.",
        "translation": "That's how I know it."
    },
    "51": {
        "startTime": 392.458,
        "endTime": 402.244,
        "transcript": "Apteqerru kitek' makunek tangerqarraallermini Kass'anek qaillun umyuarteqellrua?",
        "translation": "Please ask him, what did he think when he first saw these Caucasians?"
    },
    "52": {
        "startTime": 405.423,
        "endTime": 410.436,
        "transcript": "Kass'anek-gguq-qaa tangerqerraallerpeni qaill' umyuarteqellrusit?",
        "translation": "He asked, what did you think when you first saw Caucasians?"
    },
    "53": {
        "startTime": 410.445,
        "endTime": 419.188,
        "transcript": "Kass'amek tangerqerraallruunga, elitnauckallruyaaqua.",
        "translation": "I first saw a Caucasian, I went to school for a very short time."
    },
    "54": {
        "startTime": 420.351,
        "endTime": 430.808,
        "transcript": "Tauna elitnauristekarput cunaw' arnaq. Kitumek-am aterpaga'artellruyaaqaat. Nalluyagutaqa.",
        "translation": "It turned out that woman was going to be our teacher. They had called her something. I forgot."
    },
    "55": {
        "startTime": 430.82,
        "endTime": 434.148,
        "transcript": "Aling, tauna arnaq.",
        "translation": "Oh my, that woman."
    },
    "56": {
        "startTime": 436.613,
        "endTime": 451.513,
        "transcript": "Tuani tua-i uksuarmi elitnaurat tamakut-wa mikelnguullgutenka ilalirluki ag'aqluta.",
        "translation": "In the fall at that time, the students, I would go over with my fellow children."
    },
    "57": {
        "startTime": 454.845,
        "endTime": 466.088,
        "transcript": "Tua-i-llu iqukvarluku-w' mayurturatullruameng.",
        "translation": "Then they ended it because they always climbed."
    },
    "58": {
        "startTime": 470.871,
        "endTime": 476.097,
        "transcript": "Tuani tua-i ayallemteńi",
        "translation": "When we traveled at that time"
    },
    "59": {
        "startTime": 477.219,
        "endTime": 484.905,
        "transcript": "Cunaw' un'gavet Kuinerrarmiut kuigata kangranun",
        "translation": "Apparently, it was down to the headwaters of the river by Quinhagak"
    },
    "60": {
        "startTime": 484.916,
        "endTime": 489.244,
        "transcript": "Tamaavet cunaw' ayallemteńi tua-i.",
        "translation": "When we had apparently traveled there."
    },
    "61": {
        "startTime": 490.685,
        "endTime": 494.97,
        "transcript": "Tuani tua-i cetuvkenata tamaanlluta.",
        "translation": "There, we didn't go downriver, but stayed there."
    },
    "62": {
        "startTime": 494.979,
        "endTime": 503.222,
        "transcript": "Cunaw' tauna apqiitnek aanavut unguvaluku.",
        "translation": "Apparently, when the one they called our mother was alive."
    },
    "63": {
        "startTime": 503.233,
        "endTime": 509.39,
        "transcript": "Aipaa yuunrillra nalluaqa.",
        "translation": "I don't know when the other passed away."
    },
    "64": {
        "startTime": 509.414,
        "endTime": 521.399,
        "transcript": "Tau͡gaam im'ullratni, qungullratni ellangartellrulliniunga.",
        "translation": "But I have an early childhood memory in their, you know, graves."
    },
    "65": {
        "startTime": 521.402,
        "endTime": 527.088,
        "transcript": "Tauna qanemciklemni qanrutellruatnga",
        "translation": "When I told that story, they told me"
    },
    "66": {
        "startTime": 527.103,
        "endTime": 535.86,
        "transcript": "Tauna-gguq tangelqa wiinga atakellruaqa.",
        "translation": "They said that the one I saw was my father."
    },
    "67": {
        "startTime": 535.876,
        "endTime": 538.905,
        "transcript": "Tua-i tau͡gaam cacia nalluluku.",
        "translation": "But I didn't know what happened to him."
    },
    "68": {
        "startTime": 540.6,
        "endTime": 551.486,
        "transcript": "Tuani tua-i un'gavet cunaw' Kuinerrarmiut kuigata kangranun ayautemteńi cetuvkenata",
        "translation": "It turned out that when we went down to the headwaters of the river by Quinhagak without going downriver"
    },
    "69": {
        "startTime": 551.512,
        "endTime": 555.698,
        "transcript": "Kiagpak tua-i tamaanlluta.",
        "translation": "We were there all summer."
    },
    "70": {
        "startTime": 555.938,
        "endTime": 563.838,
        "transcript": "Taum taukut ukut ilanka ilakluki-w' tua-i.",
        "translation": "I was there with my family."
    },
    "71": {
        "startTime": 563.849,
        "endTime": 567.178,
        "transcript": "Allamek ilaunata.",
        "translation": "There was no one else with us."
    },
    "72": {
        "startTime": 567.901,
        "endTime": 579.358,
        "transcript": "Neq'ngetullinian neq'ngellrani neqsurluteng neqautengluta.",
        "translation": "Because fish would go there, they fished when the fish came, and we had a store of fish."
    },
    "73": {
        "startTime": 579.381,
        "endTime": 584.452,
        "transcript": "Mat'utun ayuqenrituq. Neq'ngelaayuituq.",
        "translation": "It's not like this [river]. Fish don't come early there."
    },
    "74": {
        "startTime": 586.095,
        "endTime": 590.281,
        "transcript": "Neq'ngelaayuitelliniuq.",
        "translation": "Apparently, fish don't come early there."
    },
    "75": {
        "startTime": 591.646,
        "endTime": 599.789,
        "transcript": "Tuani uitallruukut allrakuni tallimani. Tallimaungat'lartut umyuaqaqamni.",
        "translation": "We were there for five years. It seemed to be five as I remember it."
    },
    "76": {
        "startTime": 600.043,
        "endTime": 604.486,
        "transcript": "Wiinga-llu nukalpiarurrlua anglirilua.",
        "translation": "And I grew up to be in my prime."
    },
    "77": {
        "startTime": 607.214,
        "endTime": 610.171,
        "transcript": "Pissuryaurrlua.",
        "translation": "I started hunting."
    },
    "78": {
        "startTime": 613.71,
        "endTime": 620.381,
        "transcript": "Ayagayaurrlua kiimelnge'rma malignek pivkenii.",
        "translation": "I started traveling by myself without any companions."
    },
    "79": {
        "startTime": 623.313,
        "endTime": 631.227,
        "transcript": "Maavet uksumi ikamrarluta taillruukut cali.",
        "translation": "We also came here in the winter by sled."
    },
    "80": {
        "startTime": 632.373,
        "endTime": 643.887,
        "transcript": "Piavet [?]mun tekitukut tua-i makut kevraartut teptuut.",
        "translation": "We reached [?] inland, these spruce trees smell strong."
    },
    "81": {
        "startTime": 646.145,
        "endTime": 658.345,
        "transcript": "[?] tekitellemteńi tua-i wii makut kevraartut tepiit narellruaqa.",
        "translation": "When we reached [?], I smelled the scent of these spruce trees."
    },
    "82": {
        "startTime": 659.115,
        "endTime": 670.258,
        "transcript": "Teptulliniut waten yugtailngurmi uitarraarluni, uitamarraarluni.",
        "translation": "It turns out they smell strong after being in a place without people for a long time."
    },
    "83": {
        "startTime": 678.182,
        "endTime": 687.466,
        "transcript": "Tauna tua-i apqiitnek tauna aanavut tamaani apqucingluni augmun.",
        "translation": "At that time, the one they called out mother had an ailment in her blood."
    },
    "84": {
        "startTime": 690.196,
        "endTime": 693.967,
        "transcript": "Tua-i maanlluta.",
        "translation": "We were here."
    },
    "85": {
        "startTime": 697.793,
        "endTime": 708.693,
        "transcript": "Uksuarmi-llu cikuvailgan yuunrirluni.",
        "translation": "And in the fall, she passed away before it froze."
    },
    "86": {
        "startTime": 709.317,
        "endTime": 718.031,
        "transcript": "Assiituq. Wiinga-ll' tua-i tauna umyuaqela'arqa cali maa-i aanairutelqa.",
        "translation": "It's terrible. I still remember my late mother to this day."
    },
    "87": {
        "startTime": 719.003,
        "endTime": 720.931,
        "transcript": "Assiituq.",
        "translation": "It's terrible."
    },
    "88": {
        "startTime": 721.593,
        "endTime": 727.265,
        "transcript": "Tuarpiaq tua-i cikmilrianga.",
        "translation": "It really seems that my eyes are closed."
    },
    "89": {
        "startTime": 727.544,
        "endTime": 735.901,
        "transcript": "Camek-llu qanruyuka'rmek niitnermek taqlua ayallran kinguani.",
        "translation": "And I stopped hearing little pieces of traditional wisdom after she left."
    },
    "90": {
        "startTime": 736.33,
        "endTime": 750.302,
        "transcript": "Tau͡gaam tua-i tamaani pivailegmi tua-i qanruquralallrukiikut nauw' unguvalriani",
        "translation": "But before she passed away back then, she would always speak to us who were alive"
    },
    "91": {
        "startTime": 752.988,
        "endTime": 761.231,
        "transcript": "Tuani tua-i pillran kinguani, elitnaunrilama-llu.",
        "translation": "After she passed away then, also because I didn't go to school."
    },
    "92": {
        "startTime": 764.957,
        "endTime": 779.543,
        "transcript": "Caqerlua-am [?aagamia]llra nasperturluku uavet Naparyarrarnun piyualua ayalaama ayaglua.",
        "translation": "One day, I decided to [?], and traveled because I would walk downriver to Napakiak."
    },
    "93": {
        "startTime": 781.176,
        "endTime": 794.604,
        "transcript": "Makut-llu tan'gaurluullgutenka tanglangramki umyuamga-w' tua-i piluki aipaqsuumiinaki.",
        "translation": "And though I saw my fellow boys here, in my mind, I didn't want to play with them."
    },
    "94": {
        "startTime": 795.658,
        "endTime": 804.815,
        "transcript": "Tuani-am Naparyarrarmun tekillua au͡g'um enem ketiini nangengqaurlua uitaurlua.",
        "translation": "When I reached Napakiak, I stood toward the river from that house and stayed."
    },
    "95": {
        "startTime": 807.605,
        "endTime": 815.734,
        "transcript": "Uitaurainanemni arnaq an'uq. Ayagyuarpek'nani, nuyai-ll' qiiruluteng.",
        "translation": "As I stayed there, a woman came out. She wasn't young and her hair was gray."
    },
    "96": {
        "startTime": 816.603,
        "endTime": 823.089,
        "transcript": "Tua-i-ll' tayim' iterluni, nutaan iteryarturlua.",
        "translation": "Then she went in, and I finally went to go in."
    },
    "97": {
        "startTime": 825.367,
        "endTime": 838.838,
        "transcript": "Tua-i-ll' maaten itertua angun kiugna inglerni waten qertuvkenateng taklalria.",
        "translation": "Then when I went in, I found that there was a man in there laying on a bed that wasn't elevated."
    },
    "98": {
        "startTime": 841.239,
        "endTime": 848.71,
        "transcript": "Tua-i tang tangrramia tangvauraqerlua waqaaqiinga.",
        "translation": "When he saw me, he watched me and asked what I was there for."
    },
    "99": {
        "startTime": 849.259,
        "endTime": 853.674,
        "transcript": "Tua-i unacilluku.",
        "translation": "I shook his hand."
    },
    "100": {
        "startTime": 855.0,
        "endTime": 863.029,
        "transcript": "Tangvaglua aptaanga, \"Waqaa? Camiungusit?\"",
        "translation": "He looked at me and asked, \"What's this? Where are you from?\""
    },
    "101": {
        "startTime": 863.933,
        "endTime": 868.333,
        "transcript": "Tua-ll' piaqa Kuigglugmiungunilua.",
        "translation": "Then I told him that I was from Kwethluk."
    },
    "102": {
        "startTime": 869.801,
        "endTime": 884.444,
        "transcript": "Kuigglugmiunguniama atam uitauraqerluni maktell' ingleminek.",
        "translation": "When I said I was from Kwethluk, you see, he stayed still then got up from his bed."
    },
    "103": {
        "startTime": 885.379,
        "endTime": 895.722,
        "transcript": "Makcami wiinga-llu aqumlua ikavet akianun.",
        "translation": "When he got up, I sat across there across from him."
    },
    "104": {
        "startTime": 896.717,
        "endTime": 902.774,
        "transcript": "Tauna tua-i taringenritelqa-am tua-i tauna.",
        "translation": "At that time, I didn't understand that."
    },
    "105": {
        "startTime": 903.04,
        "endTime": 913.154,
        "transcript": "Qancuarpek'nani qanrutaanga, \"Kuigglugmiu, Kuigglugmiut.\"",
        "translation": "Without a small voice, he said to me, \"Person of Kwethluk, the people of Kwethluk.\""
    },
    "106": {
        "startTime": 917.572,
        "endTime": 929.158,
        "transcript": "Kuigglugmiunek qanrraarluni Kuigglugmiut tua-i qalarutkai taum.",
        "translation": "After he said, \"The people of Kwethluk,\" he talked about the poeple of Kwethluk."
    },
    "107": {
        "startTime": 931.023,
        "endTime": 938.78,
        "transcript": "Tua-i nalluvkenaki ilait.",
        "translation": "He knew some of them."
    },
    "108": {
        "startTime": 939.074,
        "endTime": 944.502,
        "transcript": "Nallunrilkenka ilait nalluvkenaki, ilait nalluluki",
        "translation": "He knew some of the ones I knew, and didn't know some of them"
    },
    "109": {
        "startTime": 946.24,
        "endTime": 951.354,
        "transcript": "Tekiquayuitelliniami maavet Kuigglugmun.",
        "translation": "Because apparently, he wouldn't come to Kwethluk often."
    },
    "110": {
        "startTime": 954.438,
        "endTime": 958.781,
        "transcript": "Tekitellni tauna qanrutekluku.",
        "translation": "He talked about when he came."
    },
    "111": {
        "startTime": 958.795,
        "endTime": 967.681,
        "transcript": "Tua-i-gguq kelegtuurluku, tua-i arulairceteksaunaku.",
        "translation": "They always invited him to eat, they never let him stop."
    },
    "112": {
        "startTime": 968.578,
        "endTime": 972.406,
        "transcript": "Arulaiqaqerli-gguq. Kenra tukniarutuq.",
        "translation": "Ask him to stop for a second. The battery is low."
    },
    "113": {
        "startTime": 977.777,
        "endTime": 978.963,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "114": {
        "startTime": 978.985,
        "endTime": 984.357,
        "transcript": "Mat'um-qaa, mat'um-qaa nalliini nukalpiartairutuq?",
        "translation": "Are there no more great hunters these days?"
    },
    "115": {
        "startTime": 987.799,
        "endTime": 991.884,
        "transcript": "Mat'um-gguq-qaa nalliini nukalpiartairutuq?",
        "translation": "He asked, are there no more great hunters these days?"
    },
    "116": {
        "startTime": 992.224,
        "endTime": 994.653,
        "transcript": "Mat'um-qaa nuniini?",
        "translation": "Around these parts?"
    },
    "117": {
        "startTime": 994.66,
        "endTime": 996.274,
        "transcript": "Nalliini.",
        "translation": "This time."
    },
    "118": {
        "startTime": 997.948,
        "endTime": 999.677,
        "transcript": "Catairutuq?",
        "translation": "There's no more what?"
    },
    "119": {
        "startTime": 999.692,
        "endTime": 1002.106,
        "transcript": "Mukalpiartairutuq-gguq-qaa?",
        "translation": "He asked, are there no more great hunters?"
    },
    "120": {
        "startTime": 1003.56,
        "endTime": 1006.303,
        "transcript": "Tua-i-wa",
        "translation": "Well"
    },
    "121": {
        "startTime": 1007.674,
        "endTime": 1011.245,
        "transcript": "Au͡gkut, wiinga nallunritua.",
        "translation": "People back then, I know."
    },
    "122": {
        "startTime": 1011.805,
        "endTime": 1020.262,
        "transcript": "There's going to be no more of the ones I observed back then.",
        "translation": "There's going to be no more of the ones I observed back then."
    },
    "123": {
        "startTime": 1020.469,
        "endTime": 1025.198,
        "transcript": "Only one small man.",
        "translation": "Only one small man."
    },
    "124": {
        "startTime": 1025.206,
        "endTime": 1030.749,
        "transcript": "Nutarar-qaa nallunritan? Amaqlicuar-qaa nallunritan?",
        "translation": "Do you know Nutarar? Do you know Amaqlicuar?"
    },
    "125": {
        "startTime": 1031.216,
        "endTime": 1037.83,
        "transcript": "Angukara'urluyagaur[rtuq] mikliriluni. Tauna tua-i.",
        "translation": "He's become a little old man, got small. That's him."
    },
    "126": {
        "startTime": 1038.475,
        "endTime": 1044.203,
        "transcript": "Kuigglugmiut tua-i tegganrat. Allamek tegganertaituq.",
        "translation": "The elder of Kwethluk. There is no other elder."
    },
    "127": {
        "startTime": 1044.643,
        "endTime": 1050.314,
        "transcript": "Inqigutnek tau͡gaam waten ayagyuarrlainarnek.",
        "translation": "Only [?] who are all young."
    },
    "128": {
        "startTime": 1051.282,
        "endTime": 1052.968,
        "transcript": "Tauna tua-i.",
        "translation": "That's him."
    },
    "129": {
        "startTime": 1052.972,
        "endTime": 1064.13,
        "transcript": "Ava-llam watua anlua maaten piunga keggani aqumgaururlulria kipusviim elatiini.",
        "translation": "And just now, I went out and saw the poor guy sitting outside outside of the store."
    },
    "130": {
        "startTime": 1064.651,
        "endTime": 1071.165,
        "transcript": "Mikliriuq. Qaillun angtaria?",
        "translation": "He's gotten small. How big is he now?"
    },
    "131": {
        "startTime": 1073.433,
        "endTime": 1078.704,
        "transcript": "Ilaliurlullruyaaqellria nangtulliniameng.",
        "translation": "He had a lot of family, but [families] pass away."
    },
    "132": {
        "startTime": 1079.076,
        "endTime": 1087.447,
        "transcript": "Tua-i arnamek tau͡gaam kanani aipangqertuq, anelgutii.",
        "translation": "But he has a woman for companion down there, his sibling."
    },
    "133": {
        "startTime": 1091.275,
        "endTime": 1096.018,
        "transcript": "Yugyagluki murilkellruanka.",
        "translation": "I saw them when there was a lot of them."
    },
    "134": {
        "startTime": 1096.029,
        "endTime": 1099.529,
        "transcript": "Anguterpalluut tua-i.",
        "translation": "They were mostly men."
    },
    "135": {
        "startTime": 1099.549,
        "endTime": 1110.606,
        "transcript": "Uitavkenateng, uitayuunateng. Ayagturatuluteng pissurturatullrat[ni].",
        "translation": "They weren't sedentary, were never sedentary. They would always travel when people always hunted."
    },
    "136": {
        "startTime": 1123.022,
        "endTime": 1131.108,
        "transcript": "Ingna'urluq-llu yaani kiirrara'urlurmi uitalria",
        "translation": "And the poor one over there who stays all by himself"
    },
    "137": {
        "startTime": 1132.102,
        "endTime": 1136.573,
        "transcript": "Ayapan yua, Cucuaq.",
        "translation": "Ayapan's child, Cucuaq."
    },
    "138": {
        "startTime": 1137.305,
        "endTime": 1149.491,
        "transcript": "Tauna cali aanangqellrulria taukut [?] Amaqlicuaraam iliinek arnamek.",
        "translation": "He also had a mother that was the female relative of Amaqlicuar."
    },
    "139": {
        "startTime": 1150.014,
        "endTime": 1154.757,
        "transcript": "Tuaten nallunritua. Nallunritellruaqa.",
        "translation": "That's what I know. I knew him"
    },
    "140": {
        "startTime": 1156.253,
        "endTime": 1162.064,
        "transcript": "Kinguqlingqellruyaaquq Anerniralriamek.",
        "translation": "He had a younger sibling, Anerniralria."
    },
    "141": {
        "startTime": 1163.164,
        "endTime": 1172.23,
        "transcript": "Tua-i wangtun iliini erenrem aipaqlua eniitnun aglallruunga.",
        "translation": "Some days, he would play with me and I would go to his house."
    },
    "142": {
        "startTime": 1173.312,
        "endTime": 1178.579,
        "transcript": "Wangni cangallruvkenani tua-i tarritaqluni. Aipaqaqluku.",
        "translation": "He would walk around no different from myself. I would play with him."
    },
    "143": {
        "startTime": 1180.062,
        "endTime": 1184.462,
        "transcript": "Tua-ll' Olenka.",
        "translation": "Then Olenka."
    },
    "144": {
        "startTime": 1184.582,
        "endTime": 1199.165,
        "transcript": "(Makut-qaa ayagyuat...) Tauna ing'um kiirrara'urlumi uitangelriim aanii taukut...",
        "translation": "(Do these young people...) The mother of that one who stays all by himself..."
    },
    "145": {
        "startTime": 1203.8,
        "endTime": 1206.233,
        "transcript": "Oh, yaa.",
        "translation": "Oh, okay."
    },
    "146": {
        "startTime": 1206.683,
        "endTime": 1216.133,
        "transcript": "Mat'um-qaa nalliini makut ayagyuat qanruyutnek niicuirutut, ciin-llu tanem?",
        "translation": "These days, do young people not hear traditional wisdom anymore, and why?"
    },
    "147": {
        "startTime": 1216.15,
        "endTime": 1220.25,
        "transcript": "Ilumun niicuirutut qanruyutnek.",
        "translation": "Indeed, they don't hear about traditional wisdom anymore."
    },
    "148": {
        "startTime": 1220.577,
        "endTime": 1221.477,
        "transcript": "Ciin?",
        "translation": "Why?"
    },
    "149": {
        "startTime": 1221.492,
        "endTime": 1225.659,
        "transcript": "Qalarucilrianek niicuirutut.",
        "translation": "They don't hear people teaching anymore."
    },
    "150": {
        "startTime": 1225.774,
        "endTime": 1233.074,
        "transcript": "Wangkuta atam imumi tua-i caqacuaqerqamta tua-i-ll' qanngarrlutek ukuk.",
        "translation": "For us a long time ago, you see, whenever we did any little thing, these two would start speaking."
    },
    "151": {
        "startTime": 1233.474,
        "endTime": 1237.824,
        "transcript": "Maa-i makut qanruyutmek nalluut.",
        "translation": "Now, they don't know about traditional wisdom."
    },
    "152": {
        "startTime": 1238.361,
        "endTime": 1242.728,
        "transcript": "Agayuvigmi tau͡gaam tua-i qanrut'laryaaqekait.",
        "translation": "They only tell them in church."
    },
    "153": {
        "startTime": 1247.447,
        "endTime": 1260.781,
        "transcript": "Cali-llu man'a Yugtun qalarcaraq, cagmariinalriacetun tuar pinilaqiit makut ilait tegganret.",
        "translation": "And this Yup'ik language, it seems that some elders say that it's like it's slowly getting lost."
    },
    "154": {
        "startTime": 1260.789,
        "endTime": 1267.039,
        "transcript": "Piungameng nutem wangkuta qaneryaraqluku Yugni.",
        "translation": "Because it the ancient language of us Yupiit."
    },
    "155": {
        "startTime": 1272.524,
        "endTime": 1283.058,
        "transcript": "Ak'a tamaani agayuviit tekiteqarraallratni, mat'umek-llu Qaneryaramek paivciluteng",
        "translation": "When the churches first came a long time ago, and brought forth this Bible"
    },
    "156": {
        "startTime": 1283.073,
        "endTime": 1289.64,
        "transcript": "Makunun-llu Yugnun nasvagluku taringengnaqevkarluku.",
        "translation": "And they showed it to these Yupiit to try to make them understand."
    },
    "157": {
        "startTime": 1289.651,
        "endTime": 1303.117,
        "transcript": "Maaten-gguq Yuut taringaat tamana Qaneryaraq Yugtaat imkut qaneryarait, piciryarait ayuqelallinikait.",
        "translation": "They said that when Yupiit understood it, they found that that Bible was the same as traditional Yup'ik wisdom and traditions."
    },
    "158": {
        "startTime": 1303.585,
        "endTime": 1305.801,
        "transcript": "Aren, Yuut-wa tua-i...",
        "translation": "I mean, Yupiit..."
    }
};